<template>
    <v-tooltip top>
        <template v-slot:activator="{ on: tooltip }">
            <v-btn
                v-on="{ ...tooltip }"
                small
                icon
                @click.native.stop="openDialog()">
                <v-icon>qr_code</v-icon>
                <v-dialog v-model="show" max-width="900" persistent class="round-card" :fullscreen="fullScreen || $vuetify.breakpoint.smAndDown" scrollable>
                    <v-card class="background-2 round-card">
                        <v-card-title class="pa-3">
                            <p class="pl-2 pl-xl-3">Scannerizza QRCode</p>
                            <v-spacer></v-spacer>
                            <v-btn icon @click.native.stop="fullScreen = !fullScreen"><v-icon>fullscreen</v-icon></v-btn>
                        </v-card-title>            
                        <v-divider></v-divider>
                        <v-card-text class="pa-4 px-6">
                            <span class="subtitle-1 fw500">{{ error }}</span>
                            <template v-if="!isEmpty">
                                <br><br>
                                <div>
                                    <span class="subtitle-2">Ragione Sociale: </span><span>{{ parsedResult.business_name }}</span>
                                </div>
                                <div>
                                    <span class="subtitle-2">Via: </span><span>{{ parsedResult.legal_address_street }}</span>
                                </div>
                                <div>
                                    <span class="subtitle-2">Città: </span><span>{{ parsedResult.legal_address_city }}</span>
                                </div>
                                <div>
                                    <span class="subtitle-2">Provincia: </span><span>{{ parsedResult.legal_address_province }}</span>
                                </div>
                                <div>
                                    <span class="subtitle-2">CAP: </span><span>{{ parsedResult.legal_address_zipcode }}</span>
                                </div>
                                <div>
                                    <span class="subtitle-2">Nazione: </span><span>{{ parsedResult.legal_address_country }}</span>
                                </div>
                                <div>
                                    <span class="subtitle-2">P. Iva: </span><span>{{ parsedResult.vat_number }}</span>
                                </div>
                                <div>
                                    <span class="subtitle-2">Codice Fiscale: </span><span>{{ parsedResult.fiscal_code }}</span>
                                </div>
                                <div>
                                    <span class="subtitle-2">Codice Destinatario: </span><span>{{ parsedResult.sdi_code }}</span>
                                </div>
                                <div>
                                    <span class="subtitle-2">PEC: </span><span>{{ parsedResult.pec_email }}</span>
                                </div>
                                <div>
                                    <span class="subtitle-2">Email primaria: </span><span>{{ parsedResult.primary_email }}</span>
                                </div>
                                <div>
                                    <span class="subtitle-2">Email secondaria: </span><span>{{ parsedResult.secondary_email }}</span>
                                </div>
                                <div>
                                    <span class="subtitle-2">Telefono primario: </span><span>{{ parsedResult.primary_telephone }}</span>
                                </div>
                                <div>
                                    <span class="subtitle-2">Telefono secondario: </span><span>{{ parsedResult.secondary_telephone }}</span>
                                </div>
                                <div>
                                    <span class="subtitle-2">IBAN: </span><span>{{ parsedResult.iban }}</span>
                                </div>
                                <div>
                                    <span class="subtitle-2">SWIFT: </span><span>{{ parsedResult.swift }}</span>
                                </div>
                                <!-- <div>
                                    <span class="subtitle-2">IBAN secondario: </span><span>{{ parsedResult.secondary_iban }}</span>
                                </div>
                                <div>
                                    <span class="subtitle-2">SWIFT secondario: </span><span>{{ parsedResult.secondary_swift }}</span>
                                </div> -->
                            </template>
                            <br><br>
                            <template v-if="show">

                                <qrcode-stream v-if="!error" @decode="onDecode" @init="onInit"></qrcode-stream>
                                <qrcode-capture @decode="onDecode"/>
                                <br>
                                <br>
                                <v-subheader class="pl-0">Incolla qui il codice QR</v-subheader>
                                <div v-if="parsedResult == false">
                                    <span class="subtitle-1 error--text fw500">Errore lettura QRCode</span>
                                </div>                                
                                <vue-editor
                                    id="'text-editor'"
                                    v-model="text_area"
                                    ref="editor"
                                    :editorOptions="{
                                        modules: {
                                            toolbar: false,
                                        }
                                    }"
                                ></vue-editor>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn v-if="text_area" text color="info" @click.native.stop="onDecode(text_area)" :loading="loading">Leggi</v-btn>
                                </v-card-actions>
                            </template>

                        </v-card-text> 
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn text color="info" @click.native.stop="closeDialog()">Annulla</v-btn>
                            <v-btn text color="primary" @click.native.stop="acceptParsedResult()" :loading="loading">Inserisci</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-btn>
            </template>
            <span>QRCODE Scan</span>
        </v-tooltip>
</template>
<script>
    import Vue from 'vue'
    import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from 'vue-qrcode-reader'
    //import 'vue-qrcode-reader.css'

    export default {
        name: 'QR-scan',
        components: {
            QrcodeStream,
            // QrcodeDropZone,
            QrcodeCapture            
        },

        props: {
            model: Object,
        },

        data() {
            return {
                error: '',
                result: {},
                text_area: '',
                show: false,
                loading: false,
                parsedResult: {},
                fullScreen: false,
                trans: {
                    'legal_address_country': 'Nazione',
                    'fiscal_code': 'Codice Fiscale',
                    'vat_number': 'P. Iva',
                    'business_name': 'Ragione Sociale',
                    'pec_email': 'Email PEC',
                    'sdi_code': 'Codice SDI',
                    'primary_email': 'Email primaria',
                    'secondary_email': 'Email secondaria',
                    'primary_telephone': 'Telefono primario',
                    'secondary_phone': 'Telefono secondario',
                    'iban': 'IBAN',
                    'swift': 'SWIFT',
                },
            }
        },

        computed: {
            isEmpty() {
                return _.isEmpty(this.parsedResult)
            }
        },


        methods: {

            structureResult() {
                _.forEach(this.result, (value, key) => {
                    switch(key) {
                    case 'anag':
                        Vue.set(this.parsedResult, 'legal_address_country', value.naz)
                        Vue.set(this.parsedResult, 'fiscal_code', value.cf)
                        Vue.set(this.parsedResult, 'vat_number', value.piva)
                        Vue.set(this.parsedResult, 'business_name', value.denom)
                        if(value.domFisc) {
                            Vue.set(this.parsedResult, 'legal_address_province', value.domFisc.prov)
                            Vue.set(this.parsedResult, 'legal_address_zipcode', value.domFisc.cap)
                            Vue.set(this.parsedResult, 'legal_address_city', value.domFisc.com)
                            Vue.set(this.parsedResult, 'legal_address_street', value.domFisc.ind)
                        }
                        break;
                    case 'SDI':
                        Vue.set(this.parsedResult, 'pec_email', value.pec)
                        Vue.set(this.parsedResult, 'sdi_code', value.cod)
                        break;
                    case 'extra':
                        Vue.set(this.parsedResult, 'primary_email', value.email)
                        Vue.set(this.parsedResult, 'secondary_email', value.secondary_email)
                        Vue.set(this.parsedResult, 'primary_telephone', value.phone)
                        Vue.set(this.parsedResult, 'secondary_telephone', value.secondary_phone)
                        Vue.set(this.parsedResult, 'iban', value.iban)
                        Vue.set(this.parsedResult, 'swift', value.swift)
                        // Vue.set(this.parsedResult, 'secondary_iban', value.secondary_iban)
                        // Vue.set(this.parsedResult, 'secondary_swift', value.secondary_swift)
                        break;
                    default:
                        break;
                    }
                })
            },

            onDecode (result) {
                result = result.replace(/<[^>]*>/g, '')
                if(this.$eventBusUtility.isJson(result)) {
                    this.result = JSON.parse(result)
                    this.structureResult()
                    this.acceptParsedResult()
                } else {
                    this.parsedResult = false
                }
            },

            async onInit (promise) {
                try {
                    await promise
                } catch (error) {
                    if (error.name === 'NotAllowedError') {
                        this.error = "Devi concedere l'autorizzazione di accesso alla videocamera"
                    } else if (error.name === 'NotFoundError') {
                        this.error = "Nessuna fotocamera su questo dispositivo"
                    } else if (error.name === 'NotSupportedError') {
                        this.error = "ERRORE: contesto sicuro richiesto (HTTPS, localhost)"
                    } else if (error.name === 'NotReadableError') {
                        this.error = "ERRORE: è già in uso lafotocamera?"
                    } else if (error.name === 'OverconstrainedError') {
                        this.error = "ERRORE: le telecamere installate non sono adatte"
                    } else if (error.name === 'StreamApiNotSupportedError') {
                        this.error = "ERRORE: Stream API non è supportata in questo browser"
                    }
                }
            },

            openDialog() {
                this.show = true
            },

            closeDialog() {
                this.show = false
                this.parsedResult = {}
                this.text_area = ''
            },

            acceptParsedResult() {
                this.$eventBusUtility.$emit('updateQRModel', this.parsedResult)
                this.closeDialog()
            },

        },

        created() {

        },


    }
</script>